import React from "react";
import CalendarGrid from "./calendar-grid/CalendarGrid";
import UserLayout from "../../components/Layout/UserLayout";
import {
  getListingSteps,
  resetListingSteps,
} from "../../actions/getListingSteps";
import messages from "../../locale/messages";

export default async function action({ store, intl }) {
  const title = intl?.formatMessage(messages.manageListingTab) || "Calendar";

  let isAuthenticated = store.getState().runtime.isAuthenticated;

  store.dispatch(resetListingSteps());
  await store.dispatch(getListingSteps());

  if (!isAuthenticated) {
    return { redirect: "/login" };
  }

  return {
    title,
    component: (
      <UserLayout>
        <CalendarGrid />
      </UserLayout>
    ),
  };
}
